var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIconSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66231 0.413133C5.94356 -0.149367 6.74044 -0.12593 6.99825 0.413133L8.54513 3.53032L11.967 4.02251C12.5764 4.11626 12.8108 4.86626 12.3654 5.31157L9.9045 7.72563L10.4904 11.1241C10.5842 11.7334 9.92794 12.2022 9.38888 11.9209L6.342 10.3038L3.27169 11.9209C2.73263 12.2022 2.07638 11.7334 2.17013 11.1241L2.75606 7.72563L0.295127 5.31157C-0.150185 4.86626 0.0841895 4.11626 0.693565 4.02251L4.13888 3.53032L5.66231 0.413133Z",
    fill: "#9EC2BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconSilver);
export default __webpack_public_path__ + "static/media/Star-Icon-silver.8ddf95fc75dc1edf2dd8a73d55c281db.svg";
export { ForwardRef as ReactComponent };